module.exports = __webpack_public_path__ + "dingbeauty-landing/img/system_01@1.f883d131.png";